const CashierActionType = {
  GET_CASHIER_SETTINGS: 'GET_CASHIER_SETTINGS',
  SAVE_CASHIER_GENERAL_SETTINGS: 'SAVE_CASHIER_GENERAL_SETTINGS',
  RESET_CASHIER_GENERAL_SETTINGS: 'RESET_CASHIER_GENERAL_SETTINGS',
  SAVE_CASHIER_BRAND_SETTINGS: 'SAVE_CASHIER_BRAND_SETTINGS',
  RESET_CASHIER_BRAND_SETTINGS: 'RESET_CASHIER_BRAND_SETTINGS',
  EDIT_CASHIER_GENERAL_SETTINGS: 'EDIT_CASHIER_GENERAL_SETTINGS',
};

export default CashierActionType;
